<template lang="html">
<div class="pgInner assMessage" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <span>商协会</span>
           <div class="btns">
                <el-button  @click="goFrash" size="mini">刷新</el-button>

                <el-button type="primary" size="mini" @click="goEdit('new')">
                      <span>新建</span>
                </el-button>
           </div>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input placeholder="请输入内容" v-model="listParams.keyword">
                    <el-button @click="reInxList" slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>

          <div class="inpGp">
            <el-select v-model="listParams.status" clearable placeholder="发布状态" @change="reInxList">
              <el-option
                v-for="item in options2"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

          <div class="inpGp">
            <el-select v-model="listParams.sort" placeholder="排序" @change="reInxList">
              <el-option
                v-for="item in options1"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             v-loading="loading"
             @selection-change="tabSelect"
             style="width: 100%">
             <el-table-column
               type="selection"
               align="center"
               width="30">
             </el-table-column>
             <el-table-column
               prop="title"
               label="标题">
             </el-table-column>

             <el-table-column
               label="发布者"
               width="120">

             </el-table-column>

             <el-table-column
               label="状态"
               align="center"
               width="120">
                 <template slot-scope="scope">
                      {{ scope.row.status | datFormate(1) }}
                 </template>
             </el-table-column>
             <el-table-column
               prop="updatedAt"
               width="240"
               label="更新时间">

             </el-table-column>
             <el-table-column
               label="操作"
               align="center"
               width="210">
               <template slot-scope="scope">
                  <!-- <div class="ibtn">
                    <span>预览</span>
                    <div class="dvLine"></div>
                  </div> -->
                  <div class="ibtn">
                    <span @click="goEdit('edit',scope.row)">编辑</span>
                    <div class="dvLine"></div>
                  </div>
                  <div v-if="scope.row.status==2 || scope.row.status==4" class="ibtn">
                    <span @click="goRemove(scope.row)">删除</span>
                    <div class="dvLine"></div>
                  </div>
                  <!-- <div v-if="scope.row.status==2" class="ibtn">
                    <span @click="changeState(1,scope.row)">上架</span>
                    <div class="dvLine"></div>
                  </div>
                  <div v-if="scope.row.status==1" class="ibtn">
                    <span @click="changeState(2,scope.row)">下架</span>
                    <div class="dvLine"></div>
                  </div> -->
               </template>

             </el-table-column>
          </el-table>

          <div class="table-footer">

              <div class="btns" v-if="listData.length > 0">
                  <!-- <el-button @click="changeState(1)" size="mini">上架</el-button>
                  <el-button @click="changeState(2)" size="mini">下架</el-button> -->
                  <el-button @click="goRemove()" size="mini" type="danger">删除</el-button>
              </div>


              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-size="listParams.size"
                layout="total, prev, pager, next, jumper"
                :total="allEls">
              </el-pagination>

          </div>

      </div>

</div>
</template>

<script>
import { msgList,statusSet,msgRemove } from "@/api/message/message";
import { dicSeek } from "@/api/pgMent/dictMent";
export default {
    computed:{
      lineStr:function(){
          var str = "left:" + this.navX + "px;";
          return str;
      }
    },
    filters:{
        datFormate:function(e,type){
            if(type == 1){    // 状态
                var transMap = {
                    2:'草稿',
                    3:'已发布',
                    4:'未通过'
                };
                return transMap[e];
            }
        }
    },
    data(){
        return{
            pageH:'',

            options:[],
            listData:[],
            selectArr:[],

            loading:false,

            listParams:{
              keyword:'',
              businessNewsTypeId:'',

              status:'',
              sort:2,
              no:1,
              size:12
            },

            allPages:0,
            allEls:0,

            options1:[
               { key:1,name:'更新时间正序' },
               { key:2,name:'更新时间倒序' }
            ],

            options2:[
               { key:2,name:'草稿' },
               { key:3,name:'已发布' },
               { key:4,name:'未通过' }
            ],

            typeId:''  // 活动通告类型 id
        }
    },
    methods:{
        getList:function(){
            this.loading = true;
            msgList(this.listParams).then(res => {
                this.listData = res.businessNewsList;
                this.loading = false;
                this.allPages = res.totalPages;
                this.allEls = res.totalElements;
            })
        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        goRemove:function(e){     // 批量删除
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                msgRemove({ids:this.selectArr}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择删除项！');
            }
        },

        changeState:function(status,e){
            var vues = this;
            if(e){
                this.tabSelect([e]);
            }
            if(this.selectArr.length > 0){
                statusSet({ids:this.selectArr,status:status}).then(res => {
                    vues.reInxList();
                    vues.selectArr = [];
                })
            }else{
                this.$message.error('请选择操作项！');
            }
        },

        goEdit:function(type,e){   // 编辑
            var querys = {
                typeid:this.listParams.businessNewsTypeId,
            };
            if(type == 'edit'){
                querys.id = e.id;
            }
            this.$router.push({
                path:'ass_edit',
                query:querys
            });
        },

        tabSelect:function(e){
            var arrs = [];
            e.forEach(item => {
                arrs.push(item.id);
            })
            this.selectArr = arrs;
        },

        selectChange:function(e){    // 类型
            this.listParams[e.paramsKey] = e.id;
            this.reInxList();
        },

        typeIdSet:function(){   //  获取 type
            var vues = this;
            dicSeek({code:'shangx'}).then(res => {
                 var unFormate = res.dataDictionarys;
                 unFormate.forEach(item => {
                     if(item.sort == 5){
                         vues.listParams.businessNewsTypeId = item.id;
                         return false;
                     }
                 })
                 vues.getList();
            })
        },
        handleCurrentChange:function(e){
            this.listParams.no = e;
            this.getList();
        },
        reInxList:function(){
            this.listParams.no = 1;
            this.getList();
        },
        goFrash:function(){
            this.$emit('go-frash');
        },
        prevSet:function(){

            // 底部定位
            this.pageFix();
            this.typeIdSet();


        },
    },
    created:function(){

        this.prevSet();

    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.tabNavs{
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;
  .btns{
    float: right;
    height: 60px;
    padding-right: 20px;
  }
}

.seekLine{
  padding: 20px;
  background: white;
  .seekGp{
     width: 420px;
     display: inline-block;
  }

  .inpGp{
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }
}

.pgbody{
  margin: 20px;
  .ibtn{
      display: inline-block;
      font-size: 14px;
      margin-right: 3px;
      span{
         cursor: pointer;
         color: #409EFF;
      }
      .dvLine{
         display: inline-block;
         height: 14px;
         width: 2px;
         vertical-align: middle;
         margin-top: -2px;
         margin-left: 3px;
         background: #EAEAEA;

      }
  }

  .ibtn:last-child .dvLine{
    display: none;
  }

  .table-footer{
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns{
      float: left;
      line-height: 50px;
    }

    .paging{
      display: inline-block;
      margin-top: 9px;
    }
  }

}

</style>

<style lang="scss">
.assMessage .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

.assMessage .seekLine{

  .el-input__inner{
    border-radius: 0px !important;
  }

  .el-input-group__append{
    border-radius: 0px !important;
  }

}

</style>



// WEBPACK FOOTER //
// assMessage.vue?2204310f